import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import API from '../../services/api';
import Card from '../../components/common/Card';
import Input from '../../components/common/Input';
import Select from '../../components/common/Select';
import Button from '../../components/common/Button';
import Alert from '../../components/common/Alert';
import './RegisterClient.css';

const RegisterClient = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    first_name: '',
    last_name: '',
    country_code: 'FR',
  });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState('');

  const countryOptions = [
    { value: 'FR', label: 'France' },
    { value: 'TN', label: 'Tunisie' },
    { value: 'MA', label: 'Maroc' },
    { value: 'BE', label: 'Belgique' },
    { value: 'CH', label: 'Suisse' },
    { value: 'US', label: 'États-Unis' },
  ];

  // Validation du mot de passe (version renforcée)
  const validatePasswordStrength = (password) => {
    const errors = [];
    if (password.length < 8) errors.push("8 caractères minimum");
    if (!/[A-Z]/.test(password)) errors.push("1 majuscule");
    if (!/[a-z]/.test(password)) errors.push("1 minuscule");
    if (!/[0-9]/.test(password)) errors.push("1 chiffre");
    if (!/[!@#$%^&*]/.test(password)) errors.push("1 caractère spécial (!@#$%^&*)");
    return errors;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    // Effacer l'erreur du champ modifié
    if (errors[e.target.name]) {
      setErrors({ ...errors, [e.target.name]: null });
    }
    if (apiError) setApiError('');
  };

  const validate = () => {
    const newErrors = {};

    // Email
    if (!formData.email) {
      newErrors.email = 'Email requis';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Format email invalide';
    }

    // Mot de passe
    if (!formData.password) {
      newErrors.password = 'Mot de passe requis';
    } else {
      const passwordErrors = validatePasswordStrength(formData.password);
      if (passwordErrors.length > 0) {
        newErrors.password = passwordErrors.join(' • ');
      }
    }

    // Confirmation mot de passe
    if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = 'Les mots de passe ne correspondent pas';
    }

    // Prénom
    if (!formData.first_name) {
      newErrors.first_name = 'Prénom requis';
    } else if (formData.first_name.length < 2) {
      newErrors.first_name = 'Minimum 2 caractères';
    } else if (/^\d+$/.test(formData.first_name)) {
      newErrors.first_name = 'Ne peut pas être uniquement des chiffres';
    }

    // Nom
    if (!formData.last_name) {
      newErrors.last_name = 'Nom requis';
    } else if (formData.last_name.length < 2) {
      newErrors.last_name = 'Minimum 2 caractères';
    } else if (/^\d+$/.test(formData.last_name)) {
      newErrors.last_name = 'Ne peut pas être uniquement des chiffres';
    }

    return newErrors;
  };

  // LIGNE 119 - Remplacer cette partie
const handleSubmit = async (e) => {
  e.preventDefault();
  
  const validationErrors = validate();
  if (Object.keys(validationErrors).length > 0) {
    setErrors(validationErrors);
    return;
  }

  setLoading(true);
  try {
    const { confirmPassword, ...dataToSend } = formData;
    

    await API.post('/auth/client/register', dataToSend);
    
    navigate('/login/client', { 
      state: { 
        message: 'Inscription réussie ! Vous pouvez maintenant vous connecter.' 
      } 
    });
  } catch (error) {
    const errorMsg = error.response?.data?.error || 'Erreur lors de l\'inscription';
    setApiError(errorMsg);
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="page-container">
      <div className="container" style={{ maxWidth: '550px' }}>
        <Card padding="2.5rem">
          <h1 style={{ fontSize: '2rem', fontWeight: '700', marginBottom: '0.5rem', textAlign: 'center' }}>
            Créer un compte client
          </h1>
          <p style={{ textAlign: 'center', color: '#6B7A8F', marginBottom: '2rem' }}>
            Rejoignez POINTPAY en quelques clics
          </p>

          {apiError && <Alert type="error" message={apiError} />}

          <form onSubmit={handleSubmit}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
              <Input
                label="Prénom"
                name="first_name"
                value={formData.first_name}
                onChange={handleChange}
                error={errors.first_name}
                required
              />
              <Input
                label="Nom"
                name="last_name"
                value={formData.last_name}
                onChange={handleChange}
                error={errors.last_name}
                required
              />
            </div>
            
            <Input
              label="Email"
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              error={errors.email}
              required
              autoComplete="email"
            />
            
            <Input
              label="Mot de passe"
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              error={errors.password}
              required
              autoComplete="new-password"
            />
            
            <Input
              label="Confirmer le mot de passe"
              type="password"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              error={errors.confirmPassword}
              required
              autoComplete="new-password"
            />
            
            <Select
              label="Pays"
              name="country_code"
              value={formData.country_code}
              onChange={handleChange}
              options={countryOptions}
            />

            <Button type="submit" variant="primary" fullWidth disabled={loading}>
              {loading ? 'Inscription en cours...' : "S'inscrire"}
            </Button>
          </form>

          <p style={{ textAlign: 'center', marginTop: '2rem', color: '#6B7A8F' }}>
            Déjà un compte ?{' '}
            <Link to="/login/client" style={{ color: '#0066FF', textDecoration: 'none', fontWeight: '500' }}>
              Connectez-vous
            </Link>
          </p>
        </Card>
      </div>
    </div>
  );
};

export default RegisterClient;